export const SET_CREDENTIALS = 'set_credentials';
export const CHANGE_PAGE = 'change_page';
export const CHANGE_APP_PAGE = 'change_app_page';
export const CHANGE_DIALOG_PAGE = "change_dialog_page";
export const CHANGE_APP_PAGE_ACTION = 'change_app_page_action';

export const changePage = (page) => ({ type: CHANGE_PAGE, page });
export const changeAppPage = (appPage, data) => ({ type: CHANGE_APP_PAGE, appPage, data });
export const changeDialogPage = (dialogPage) => ({ type: CHANGE_DIALOG_PAGE, dialogPage });
export const changeAppPageAction = (action, data) => ({ type: CHANGE_APP_PAGE_ACTION, action, data });

export function setCredentials(username, password) {
    return { type: SET_CREDENTIALS, username, password };
}